export const FILE_UPLOAD_REQUEST = 'FILE_UPLOAD_REQUEST';
export const FILE_UPLOAD_PROGRESS = 'FILE_UPLOAD_PROGRESS';
export const FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS';
export const FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR';
export const FILE_UPLOAD_CANCEL = 'FILE_UPLOAD_CANCEL';

export const cancelFileUpload = (id) => {
    return {type: FILE_UPLOAD_CANCEL, payload: {id}};
};

export const fileUploadSuccess = (payload) => {
    return {type: FILE_UPLOAD_SUCCESS, payload};
};

export const fileUploadError = (id, message) => {
    return {type: FILE_UPLOAD_ERROR, payload: {id, message}};
};

export const fileUploadProgress = (id, progress) => {
    return {type: FILE_UPLOAD_PROGRESS, payload: {id, progress}};
};

export const uploadFile = (containerId, id, file, path, method='POST') => {

    return {
        type: FILE_UPLOAD_REQUEST,
        payload: {
            containerId,
            id,
            file,
            path,
            method: method
        }
    };
};




// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/fileUpload.js